import useApi from '@components/Hooks/useApi';
import useGlobalState from '@components/Hooks/useGlobalState';
import useSiteConfig from '@components/Hooks/useSiteConfig';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import useValidation from '../Hooks/useValidation';
import Email from '../Shared/Forms/Email';
import Phone from '../Shared/Forms/Phone';
import Text from '../Shared/Forms/Text';
import TextArea from '../Shared/Forms/TextArea';
import Captcha from './Captcha';
import ContactAdminSubmit from './Submit';

const ContactAdminForm: React.FC = () => {

  const [store, dispatch] = useGlobalState();
  const api = useApi(dispatch);
  const site_config = useSiteConfig();

  const [message, setMessage] = useState<string>('');
  const [first_name, setFirstName] = useState<string>('');
  const [last_name, setLastName] = useState<string>('');
  const [phone_number, setPhoneNumber] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [captcha_response, setCaptchaResponse] = useState<string | null>(null);
  const { isNotEmpty, isPhoneNumber, isEmail } = useValidation();

  const verifyCaptcha = (token: string | null): void => {
    setCaptchaResponse(token);
  }

  const shouldShowCaptcha = (): boolean => {
    return isNotEmpty(message) && isNotEmpty(first_name) && isNotEmpty(last_name) && isPhoneNumber(phone_number) && isEmail(email);
  }

  const shouldShowSubmit = (): boolean => {
    return shouldShowCaptcha();
    // return shouldShowCaptcha() && isNotEmpty(captcha_response);
  }

  const submit = (): void => {
    if (site_config) {
      api.sendMessage(message, first_name, last_name, phone_number, email, captcha_response!, site_config.domain);
    }
  }

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    submit();
    // handle form submission
  };

  return (!store.requested && site_config) ? (
    <>
      <Row>
        <Col xs={12}>

          <h2>Enter Your Contact Information</h2>

          <p>We&apos;ll locate your <b>local</b> administrator(s) based
            on <b>your</b> contact information.</p>

          <form style={{ marginTop: -1 }} onSubmit={handleSubmit}>
            <Text name='first_name' title='Your First Name' value={first_name} setter={setFirstName} required />
            <Text name='last_name' title='Your Last Name' value={last_name} setter={setLastName} required />
            <Phone name='phone_number' title='Your Phone Number' value={phone_number} setter={setPhoneNumber} required />
            <Email name='email' title='Your Email' value={email} setter={setEmail} required />
            <TextArea name='message' title='Message' value={message} setter={setMessage} required />
            <Captcha show={shouldShowCaptcha()} verify={verifyCaptcha} />
            <ContactAdminSubmit show={shouldShowSubmit()} />
          </form>

        </Col>
      </Row>

    </>
  ) : null;
}

export default ContactAdminForm;